import React from 'react'
import PDFObject from 'pdfobject'

import { ZariContext } from '_zari/context'
import { Row, Col } from '_zari/core'

import * as FacturacionService from 'services/facturacion.service'

const SegundaImpresionFormat = ({ pdfHash }) => {
  const __zariContext = React.useContext(ZariContext)

  React.useEffect(() => {
    FacturacionService.self
      .descargarPdfv2xId(pdfHash)
      .then(({ data }) => {
        var file = new Blob([data], { type: 'application/pdf' })
        var fileURL = URL.createObjectURL(file)

        PDFObject.embed(fileURL, '#pdf-segundaImpresionFormat-viewer', {
          height: '70vh',
          pdfOpenParams: { view: 'FitV', page: '1' }
        })
      })
      .catch(() => {
        __zariContext.snack('warning', 'La venta se completo pero no se pudo descargar el documento.')
      })
  }, [__zariContext, pdfHash])

  return (
    <Col md={6}>
      <Row className='mb-2'>
        <Col md={12} className='text-center'>
          <h4>IMPRESIÓN SECUNDARIA</h4>
        </Col>
      </Row>
      <Row>
        <Col id='pdf-segundaImpresionFormat-viewer' md={12}></Col>
      </Row>
    </Col>
  )
}

export default React.memo(SegundaImpresionFormat)
